var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { "align-center": "", "justify-center": "" } },
    [
      _c("modalAlert", { ref: "modalAlert" }),
      _c(
        "v-row",
        { attrs: { justify: "space-around" } },
        [
          _c(
            "v-card",
            {
              attrs: {
                width: "100%",
                "max-width": "800px",
                elevation: "24",
                loading: _vm.bFlagLoading
              }
            },
            [
              _c(
                "v-toolbar",
                { attrs: { color: "light-blue", dark: "", flat: "" } },
                [
                  _c("v-toolbar-title", [_vm._v("Registro de eleitor")]),
                  _c("v-spacer"),
                  _c("v-tooltip", { attrs: { right: "" } }, [void 0], 2)
                ],
                1
              ),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-form",
                    { ref: "formVoterRegistration" },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Eleição",
                          rules: _vm.requiredRules,
                          readonly: ""
                        },
                        model: {
                          value: _vm.electionName,
                          callback: function($$v) {
                            _vm.electionName = $$v
                          },
                          expression: "electionName"
                        }
                      }),
                      _c("v-text-field", {
                        attrs: { label: "Nome", rules: _vm.requiredRules },
                        model: {
                          value: _vm.name,
                          callback: function($$v) {
                            _vm.name = $$v
                          },
                          expression: "name"
                        }
                      }),
                      _c("v-text-field", {
                        attrs: {
                          label: "E-mail",
                          rules: _vm.emailValidation(),
                          readonly: ""
                        },
                        model: {
                          value: _vm.email,
                          callback: function($$v) {
                            _vm.email = $$v
                          },
                          expression: "email"
                        }
                      }),
                      _c("v-text-field", {
                        attrs: { label: "CPF", rules: [_vm.cpfValidate] },
                        on: { keyup: _vm.formatCPF },
                        model: {
                          value: _vm.cpf,
                          callback: function($$v) {
                            _vm.cpf = $$v
                          },
                          expression: "cpf"
                        }
                      }),
                      _c("v-text-field", {
                        attrs: { label: "RG" },
                        model: {
                          value: _vm.rg,
                          callback: function($$v) {
                            _vm.rg = $$v
                          },
                          expression: "rg"
                        }
                      }),
                      _c("v-text-field", {
                        attrs: {
                          label: "Título de eleitor",
                          rules: [_vm.validateElectorTitle]
                        },
                        on: { keyup: _vm.formatElectorTitle },
                        model: {
                          value: _vm.treNumber,
                          callback: function($$v) {
                            _vm.treNumber = $$v
                          },
                          expression: "treNumber"
                        }
                      }),
                      _c("v-text-field", {
                        attrs: {
                          label: "Zona do título",
                          type: "number",
                          rules: _vm.requiredRules
                        },
                        model: {
                          value: _vm.treZone,
                          callback: function($$v) {
                            _vm.treZone = $$v
                          },
                          expression: "treZone"
                        }
                      }),
                      _c("v-text-field", {
                        attrs: { label: "Seção do título", type: "number" },
                        model: {
                          value: _vm.treSection,
                          callback: function($$v) {
                            _vm.treSection = $$v
                          },
                          expression: "treSection"
                        }
                      }),
                      _c("v-text-field", {
                        attrs: {
                          label: "Data de nascimento",
                          type: "date",
                          rules: _vm.requiredRules
                        },
                        model: {
                          value: _vm.birth,
                          callback: function($$v) {
                            _vm.birth = $$v
                          },
                          expression: "birth"
                        }
                      }),
                      _c("v-text-field", {
                        attrs: {
                          label: "Nome da mãe",
                          rules: _vm.requiredRules
                        },
                        model: {
                          value: _vm.motherName,
                          callback: function($$v) {
                            _vm.motherName = $$v
                          },
                          expression: "motherName"
                        }
                      }),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { align: "center", justify: "center" } },
                            [
                              _c("vue-recaptcha", {
                                ref: "recaptcha",
                                attrs: { sitekey: _vm.sitekey },
                                on: { verify: _vm.onVerify }
                              }),
                              _vm.showMessageRecaptcha
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "v-messages theme--light error--text"
                                    },
                                    [_vm._v(_vm._s(_vm.msgCaptcha))]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    { attrs: { color: "primary" }, on: { click: _vm.salvar } },
                    [_vm._v(" Salvar ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }